import { useRef } from "react";
import { FluentButton } from "../../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../../assets/fluent-ui-icon";
import { Tooltip } from "@fluentui/react-components";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { getJuniorBankersColumns, getResourceLogColumns, getResourceLogColumnsGrouped, handleExportGroupedBySectorSingleSheet, mapEnergyExportData } from "../../dashboard-energy-banker/energy-banker-time-log/energy-banker-time-log-helper";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

const DashboardEnergyStafferDealResourceLogHeader = ({ energyStafferDealResourceLogItems, user, resetDataState, dealState, expandWidget, expandClass, isSI = false }) => {
    const _dealLogExport = useRef(null);
    const _juniorBankersExport = useRef(null);
    const bankers = energyStafferDealResourceLogItems?.Deals?.map(item => item.JuniorBankers.map(b => ({ ...b, ProjectId: item.ProjectId, ProjectName: item.ProjectName, Company: item.Company }))).flat() || [];
    const hasAnyFilter =
        dealState.filter &&
        Array.isArray(dealState.filter.filters) &&
        dealState.filter.filters.length > 0;
    const canReset = dealState.sort.length > 0 || hasAnyFilter;

    const history = useHistory();
    const canCreate = user?.currentUser?.privileges?.["Projects"]?.Add ?? false;
    return (
        <>
            <div className="widget-header" data-testid="header">
                <div className="header-left">
                    <div className="main-title-badge-row">
                        <div className="main-title">Deal Details And Resourcing Log</div>
                    </div>
                    <div className="sub-title">{isSI ? 'GIB/Energy/Summer Internship' : 'GIB/Energy'}</div>
                </div>
                <div className="header-right">
                    <Tooltip content="Reset Filters and Sorting">
                        <span>
                        <FluentButton
                            appearance="secondaryWithOutline"
                            icon={
                                <FluentUiIcon
                                    name="ArrowResetRegular"
                                    color={canReset ? "#0F6CBD" : "#A0A0A0"}
                                    size={20}
                                    disabled={!canReset}
                                />
                            }
                            disabled={!canReset}
                            onClick={resetDataState}
                        />
                        </span>
                    </Tooltip>
                    {energyStafferDealResourceLogItems?.Deals?.length > 0 &&
                        <Tooltip content="Export Data">
                            <span>
                            <FluentButton
                                appearance="secondaryWithOutline"
                                icon={
                                    <FluentUiIcon
                                        name="ArrowDownloadRegular"
                                        color="#0F6CBD"
                                        size={20}
                                    />
                                }
                                onClick={() =>
                                    handleExportGroupedBySectorSingleSheet({ data: mapEnergyExportData(energyStafferDealResourceLogItems?.Deals), columnsGrouped: getResourceLogColumnsGrouped , emptySectors: energyStafferDealResourceLogItems?.EmptySectors, priorityOrder: energyStafferDealResourceLogItems?.SectorNames })
                                }
                            />
                            </span>
                        </Tooltip>
                    }
                    <Tooltip content="Expand Widget">
                        <span>
                        <FluentButton
                            appearance="secondaryWithOutline"
                            icon={
                                <FluentUiIcon
                                    name={
                                        expandClass === "widgetExpanded"
                                            ? "FullScreenMinimizeFilled"
                                            : "FullScreenMaximizeFilled"
                                    }
                                    color={"#0F6CBD"}
                                    size={20}
                                />
                            }
                            onClick={expandWidget}
                        />
                        </span>
                    </Tooltip>
                    <FluentButton
                        text="Create Deal"
                        appearance="secondaryWithOutline"
                        disabled={!canCreate}
                        icon={
                            <FluentUiIcon
                                name="FolderAddRegular"
                                color={canCreate ? "#0F6CBD" : "#A0A0A0"}
                                size={20}
                            />
                        }
                        onClick={() => {
                            if (canCreate) {
                                history.push({
                                    pathname: "/projects/create",
                                    state: { fromDashboard: true },
                                });
                            }
                        }}
                    />                    
                </div>
            </div>
            <ExcelExport data={mapEnergyExportData(energyStafferDealResourceLogItems?.Deals)} ref={_dealLogExport}>
                {getResourceLogColumns()}
            </ExcelExport>
            <ExcelExport data={mapEnergyExportData(bankers)} ref={_juniorBankersExport}>
                {getJuniorBankersColumns()}
            </ExcelExport>
        </>
    );
};

DashboardEnergyStafferDealResourceLogHeader.propTypes = {
    energyStafferDealResourceLogItems: PropTypes.shape({
        Deals: PropTypes.array,
        EmptySectors: PropTypes.array,
        SectorNames: PropTypes.array,
    }),
    user: PropTypes.object,
    resetDataState: PropTypes.func,
    dealState: PropTypes.shape({
        filter: PropTypes.object,
        sort: PropTypes.array
    }),
    expandWidget: PropTypes.func,
    expandClass: PropTypes.string,
    isSI: PropTypes.bool,
};
export default DashboardEnergyStafferDealResourceLogHeader;